// Pull a human-readable message out of an axios error. Server user routes
// respond with JSON { message } on failure; older/other routes may still send
// plain-text bodies. Falls back to the supplied copy for network errors.
const getApiErrorMessage = (error, fallback) =>
  error?.response?.data?.message ||
  // blockVerifiedTripEdit* guards answer 403 with { error: "<reason>" }
  (typeof error?.response?.data?.error === "string" && error.response.data.error) ||
  (typeof error?.response?.data === "string" && error.response.data) ||
  fallback;

export default getApiErrorMessage;
